import type { CMSConfig } from '#types/config/components/cms'
import type { RecursivePartial } from '#types/utils'

export default {
  presets: {
    size: {
      height: {
        sm: 300,
        md: 200
      },
      width: {
        sm: 300,
        md: 200
      }
    }
  }
} satisfies RecursivePartial<CMSConfig['productRecommendations']>
